__turbopack_context__.v({
  "cartButton": "cart-button-module__nvTdla__cartButton",
  "quantity": "cart-button-module__nvTdla__quantity",
});
